import React, { useState } from 'react';
import { Route, Router, Switch } from 'react-router-dom';

// Auth0
import { useAuth0 } from '@auth0/auth0-react';

// page components
import Footer from './components/Footer';
import Loading from './components/Loading';
import NavBar from './components/Navbar/NavBar';
import NotificationBar from './components/SnackBar/NotificationBar';

// page views
import { Box, styled } from '@mui/material';
import Action from './views/Action';
import AddSchool from './views/AddSchool';
import BookTeacher from './views/BookTeacher';
import EmailVerificationNeeded from './views/EmailVerificationNeeded';
import ErrorScreen from './views/ErrorScreen';
import History from './views/History';
import Home from './views/Home';
import InvitationSignup from './views/InvitationSignup';
import NoPageFound from './views/NoPageFound';
import Profile from './views/Profile';
import NotificationList from './components/NewLayout/NotificationList';
import Root from './views/Root';
import SavedTeachers from './views/SavedTeachers';
import SignUp from './views/SignUp';
import TeacherAvailability from './views/TeacherAvailability';
import SchoolBooking from './views/ViewSchoolBooking';
import TeacherBooking from './views/ViewTeacherBooking';
import BottomNavigationBar from './components/Navbar/BottomNavigationBar';
import searchJobs from './views/SearchJobs';
import SchoolJobs from './views/SchoolJobs';
import UnsubscribePage from './views/UnsubscribePage';
import WhyUs from './views/WhyUs';

// Utilities
import history from './utils/history';

// Material UI
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './muiTheme';

// React Redux
import { Provider } from 'react-redux';
import store from './redux/store';

// Websocket
//import { w3cwebsocket as W3CWebSocket } from 'websocket';

// Font Awesome
import Content from './components/Content';
import initFontAwesome from './utils/initFontAwesome';
import { install } from 'ga-gtag';
initFontAwesome();

// const client = new W3CWebSocket(
//     'wss://9t2pdm64fd.execute-api.ap-southeast-2.amazonaws.com/dev'
// );
const drawerWidth = 240;
const isRootURL = window.location.pathname === '/';
const AppArea = styled('div')(({ theme }) => ({
    minHeight: '100vh',
    flexGrow: 1,
    width: '100%',
    transition: 'transform 0.3s ease-out',
    [theme.breakpoints.up('md')]: {
        width: isRootURL ? `100%` : `calc(100% - ${drawerWidth}px)`,
        marginLeft: isRootURL ? `0px` : `${drawerWidth}px`,
    },
}));

const App = () => {
    const [state] = useState({
        error: false,
        errorMessage: [],
    });
    const [displayEmailVerify] = useState(false);

    const { isLoading, error } = useAuth0();

    //useEffect(() => {
    //    if (
    //        user !== undefined &&
    //        user.email_verified !== undefined &&
    //        user.email_verified === false
    //    ) {
    //        setDisplayEmailVerify(true);
    //    }
    //}, [user]);

    install('G-DLSBZEFK6W');
    //install('G-DLSBZEFK6W', { 'send_page_view': false });

    // useEffect(() => {
    //     client.onopen = () => {
    //         console.log('WebSocket Client Connected');
    //     };
    //     client.onmessage = message => {
    //         console.log(message);
    //     };
    // });

    if (error) {
        //Hit with this erro http://localhost:3000/home?error=access_denied&error_description=You%20may%20have%20pressed%20the%20back%20button%2C%20refreshed%20during%20login%2C%20opened%20too%20many%20login%20dialogs%2C%20or%20there%20is%20some%20issue%20with%20cookies%2C%20since%20we%20couldn%27t%20find%20your%20session.%20Try%20logging%20in%20again%20from%20the%20application%20and%20if%20the%20problem%20persists%20please%20contact%20the%20administrator.&state=LndCZWNVVWZmREFJY1BUNGVFREJuSDMwaUoyaXRvRnYxbVZhTy1kM0tjMA%3D%3D
        return (
            <div
                style={{
                    height: '100vh',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '17px',
                }}
            >
                Ohh a strange error occured... {error.message}
                <br />
                <br />
                <br />
                <a
                    href="/home"
                    style={{
                        fontSize: '18px',
                        lineHeight: '1.2em',
                        fontWeight: '500',
                        textDecoration: 'none',
                        boxShadow: '0px 0px 10px 0px rgba(53,56,240,0.5)',
                        borderRadius: '30px',
                        padding: '15px 30px',
                        background: '#06d9fa',
                        color: '#ffffff',
                    }}
                >
                    Back to Home Page
                </a>
            </div>
        );
        //fix this to be a better and informative page
    }

    if (isLoading) {
        return <Loading />;
    }

    console.log('isRootURL', isRootURL, 'isRootURL');
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <div id="page-container">
                    <Router history={history}>
                        <Box
                            id="content-wrap"
                            sx={{
                                'background-color': '#f0f2f5',
                            }}
                        >
                            <div id="app">
                                <Switch>
                                    <Route
                                        path="/unsubscribe"
                                        exact
                                        component={UnsubscribePage}
                                    />
                                </Switch>
                                <NavBar />
                                <AppArea>
                                    {displayEmailVerify ? (
                                        <div>
                                            {!state.error && (
                                                <Switch>
                                                    <Route
                                                        path="/home"
                                                        exact
                                                        component={Home}
                                                    />
                                                    <Route
                                                        path="/addSchool"
                                                        component={AddSchool}
                                                    />
                                                    <Route
                                                        children={
                                                            EmailVerificationNeeded
                                                        }
                                                    />
                                                </Switch>
                                            )}
                                        </div>
                                    ) : (
                                        <Switch>
                                            {!state.error && (
                                                <Route
                                                    path="/home"
                                                    exact
                                                    component={Home}
                                                />
                                            )}
                                            <Route
                                                path="/profile/:route"
                                                component={Profile}
                                            />

                                            <Route
                                                path="/notifications"
                                                component={NotificationList}
                                            />
                                            <Route
                                                path="/whyus"
                                                component={WhyUs}
                                            />
                                            <Route
                                                path="/signup"
                                                component={SignUp}
                                            />
                                            <Route
                                                path="/invitationSignup"
                                                component={InvitationSignup}
                                            />
                                            <Route
                                                path="/history"
                                                component={History}
                                                exact
                                            />
                                            <Route
                                                path="/action"
                                                component={Action}
                                                exact
                                            />
                                            <Route
                                                path="/history/school-booking"
                                                component={SchoolBooking}
                                            />
                                            <Route
                                                path="/history/teacher-booking"
                                                component={TeacherBooking}
                                            />
                                            <Route
                                                path="/teacher-availability/teacher-booking"
                                                component={TeacherBooking}
                                            />
                                            <Route
                                                path="/book-teacher"
                                                component={BookTeacher}
                                            />

                                            <Route
                                                path="/casual-relief-teacher-list"
                                                component={SavedTeachers}
                                            />
                                            <Route
                                                path="/content"
                                                component={Content}
                                            />

                                            <Route
                                                path="/addSchool"
                                                component={AddSchool}
                                            />

                                            <Route
                                                path="/Jobs"
                                                component={searchJobs}
                                            />
                                            <Route
                                                path="/schooljobs"
                                                component={SchoolJobs}
                                            />
                                            <Route
                                                path="/loading"
                                                component={Loading}
                                            />

                                            {state.error && (
                                                <Route
                                                    path="/"
                                                    component={ErrorScreen}
                                                />
                                            )}
                                            {!state.error && (
                                                <Route
                                                    path="/"
                                                    exact
                                                    component={Root}
                                                />
                                            )}
                                            <Route
                                                path="/teacher-availability"
                                                component={TeacherAvailability}
                                                exact
                                            />
                                            <Route children={NoPageFound} />
                                        </Switch>
                                    )}
                                </AppArea>
                            </div>
                        </Box>
                        <NotificationBar />

                        {/* <Footer /> desktop below bottom navigation*/}
                        <BottomNavigationBar />
                    </Router>
                </div>
            </ThemeProvider>
        </Provider>
    );
};

export default App;
